export default __webpack_public_path__ + "static/media/vinho tinto 2.ce050eb8.png";